import { Box, Backdrop, CircularProgress, Typography } from '@mui/material';
import { circularProgressClasses } from '@mui/material/CircularProgress';
import { useAnalysisStore } from '../../store/useAnalysisStore';

interface LoadingProgressProps {
  open: boolean;
}

export default function LoadingProgress({ open }: LoadingProgressProps) {
  const progress = useAnalysisStore((s) => s.loadingProgress);

  return (
    <Backdrop
      open={open}
      sx={{
        backgroundColor: 'transparent',
        color: '#5EBEBB',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        {/* 배경 */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={130}
          thickness={4}
          sx={{
            color: '#BCBCBCB2',
            position: 'absolute',
            left: 0,
            top: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
        />
        {/* 프로그레스 */}
        <CircularProgress
          variant="determinate"
          value={progress}
          size={130}
          thickness={4}
          sx={{ color: '#74DFE0D9' }}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#F9F9F9', fontWeight: 700, fontSize: '24px' }}
          >
            {`${Math.round(progress)}%`}
          </Typography>
        </Box>
      </Box>
    </Backdrop>
  );
}

